import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Aux from '../../hoc/Aux';
import { useForm } from 'react-hook-form';
import * as actions from '../../store/actions/index';
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const passwordForgotten = (props) => {

  const { register, setError, errors, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const [sendEmailResult, setSendEmailResult] = useState(false);
  const ct = useCustomTranslation();

  const onSubmit = data => {
    dispatch( actions.newPasswordRequest(data) ).then( (res) => {
      (res && res.errors)? errorHandling(res.errors) : setSendEmailResult(true)
    });
  } ;

  const errorHandling = (e) => {
    if ( Array.isArray(e['email']) ) {
      setError("email", {
              type: "manual",
              message: ct('form.register.errors.email.' + e['email'][0]['error'] )
            });
    }
  }

  const intialValues = {
    email: "",
  };

  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName])?
       <div className="invalid-feedback">
          { ct('form.register.errors.' + fieldName + '.required') }
        </div> : null
  }

  return (
    <Aux>
      <div className="main-container-login vertical-center">
        <div className="container">
          <div className="row justify-content-center">
             <div className="col-xl-5 col-lg-6 col-md-7">
                <div className="text-center">
                   <h1 className="h2">{ ct('password_forgotten.headline') }</h1>

                    { (sendEmailResult === true)?

                     <div className="page-header">
                          <div className="card card-note" style={{paddingTop: "20px"}}>
                            <div className="card-body">
                              <p className="lead" >{ ct('passwort_forgotten.email_sent') }</p>
                            </div>
                          </div>
                      </div>
                    :
                       <Aux>
                         <p className="lead" style={{paddingBottom: "30px"}}>{ ct('password_forgotten.subheadline') }</p>
                         <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-group">
                              <input
                                className={(errors.email)? "form-control is-invalid" : "form-control"}
                                name="email"
                                defaultValue={intialValues.email}
                                ref={register({ required: true})} />
                               { (errors.email)?
                                   <div className="invalid-feedback">
                                      {errors.email.message}
                                    </div> : null
                                }
                                { errors.email && !errors.email.message && errorMessage(errors, 'email') }

                               <div className="text-right">
                                 <small>
                                   <Link to={ROUTES.TO_LOGIN}>{ ct('password_forgotten.link.to_to_login') }</Link>
                                 </small>
                               </div>
                            </div>
                            <button className="btn btn-lg btn-block btn-primary" type="submit">
                            { ct('password_forgotten.button.send_recovery_mail') }
                            </button>
                         </form>
                      </Aux>
                   }


              </div>
            </div>
          </div>
        </div>
      </div>
    </Aux>
  )
};

export default passwordForgotten;



// WEBPACK FOOTER //
// ./src/components/Auth/PasswordForgotten.js